import * as Yup from 'yup';
import {getErrorMessage} from './getMessages';
import {
  emailRegex,
  phoneRegex,
  nameRegex,
  passwordRegex,
} from 'constants/regex';

export const ForgetPasswordEmailValidation = Yup.object({
  email: Yup.string()
    .matches(emailRegex, getErrorMessage('E-10080'))
    .required(getErrorMessage('E-10082')),
});

export function ForgetPassWordEmailValidationAfterLogin(email: string) {
  return Yup.object({
    email: Yup.string()
      .matches(emailRegex, getErrorMessage('E-10080'))
      .test(
        'match-auth-email',
        getErrorMessage('E-10108'),
        value => value === email,
      )
      .required(getErrorMessage('E-10082')),
  });
}

export const OTPValidation = Yup.object({
  otp: Yup.string().length(6).required(getErrorMessage('E-10083')),
});

export const LoginValidation = Yup.object({
  email_id: Yup.string()
    .matches(emailRegex, getErrorMessage('E-10002'))
    .required(getErrorMessage('E-10007')),
  password: Yup.string().required(getErrorMessage('E-10056')),
});

export const AddEmployeeValidation = Yup.object({
  first_name: Yup.string()
    .matches(nameRegex, getErrorMessage('E-10110'))
    .max(15, getErrorMessage('E-10090')) // Max 15 characters
    .required(getErrorMessage('E-10023')), // Must not be empty

  last_name: Yup.string()
    .matches(nameRegex, getErrorMessage('E-10110'))
    .max(15, getErrorMessage('E-10090')), // Max 15 characters, optional field

  phone: Yup.string()
    .matches(phoneRegex, getErrorMessage('E-10064')) // Exactly 10 digits, only numbers
    .nullable(),

  email: Yup.string()
    .matches(emailRegex, getErrorMessage('E-10002')) // valid email
    .required(getErrorMessage('E-10033')), // must not be empty
  personal_email: Yup.string().matches(emailRegex, getErrorMessage('E-10002')), // valid email

  dob: Yup.date()
    .nullable()
    .required(getErrorMessage('E-10025'))
    .max(
      new Date(new Date().setDate(new Date().getDate() - 1)),
      getErrorMessage('E-10038'),
    ), // No future dates
  date_of_joining: Yup.date().nullable().required(getErrorMessage('E-10041')),
});

export const AddProjectValidation = Yup.object({
  name: Yup.string().required(getErrorMessage('E-10011')),
  start_date: Yup.date().nullable(),
  end_date: Yup.date()
    .nullable()
    .min(Yup.ref('start_date'), getErrorMessage('E-10021')),
  sprint_duration: Yup.number(),
});

export const UpdateEmployeeValidation = Yup.object({
  emp_id: Yup.string().required(getErrorMessage('E-10061')),
  first_name: Yup.string()
    .matches(nameRegex, getErrorMessage('E-10110'))
    .max(15, getErrorMessage('E-10090')) // Max 15 characters
    .required(getErrorMessage('E-10023')), // Must not be empty

  last_name: Yup.string()
    .matches(nameRegex, getErrorMessage('E-10110'))
    .max(15, getErrorMessage('E-10090')), // Max 15 characters, optional field

  dob: Yup.date()
    .nullable()
    .required(getErrorMessage('E-10025'))
    .max(new Date(), getErrorMessage('E-10038')), // No future dates
  date_of_joining: Yup.date().nullable().required(getErrorMessage('E-10041')),
});

export const QuickAddUserStoryValidation = Yup.object({
  title: Yup.string().required(getErrorMessage('E-10063')),
});

export const ResetPasswordValidation = Yup.object({
  current_password: Yup.string().required(getErrorMessage('E-10075')),
  new_password: Yup.string()
    .required(getErrorMessage('E-10056'))
    .matches(passwordRegex, getErrorMessage('E-10076'))
    .notOneOf([Yup.ref('current_password')], getErrorMessage('E-10107')),
  confirm_password: Yup.string()
    .required(getErrorMessage('E-10077'))
    .oneOf([Yup.ref('new_password')], getErrorMessage('E-10077')),
});

export const ForgotPasswordValidation = Yup.object({
  new_password: Yup.string()
    .required(getErrorMessage('E-10056'))
    .matches(passwordRegex, getErrorMessage('E-10076')),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password')], getErrorMessage('E-10077'))
    .required(getErrorMessage('E-10077')),
});

export const UpdateProfileValidation = Yup.object({
  personal_email: Yup.string().required(getErrorMessage('E-10092')),
  phone: Yup.string().required(getErrorMessage('E-10091')),
});


export const RegisterOrganizationValidation = Yup.object({
  org_name: Yup.string().required(getErrorMessage('E-10095')),
  first_name: Yup.string().matches(nameRegex, getErrorMessage('E-10110')).required(getErrorMessage('E-10097')),
  last_name: Yup.string().matches(nameRegex, getErrorMessage('E-10110')),
  email: Yup.string().matches(emailRegex, getErrorMessage('E-10002')).required(getErrorMessage('E-10007')),
});
